import {Component, ElementRef, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Router} from "@angular/router";

import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {wordHanjaMixin} from "../../mixins/word-hanja.mixin";


@Component({
  selector: 'app-hanja-char',
  template: `{{ hanja ? hanja : '' }}`,
})
export class HanjaCharComponent extends wordHanjaMixin implements OnInit, OnDestroy {
  @Input() hanja?: string;

  private unlisten: (() => void) | null = null;

  constructor(
    public router: Router,
    public dynamicSvc: DynamicComponentService,
    public lm: LayoutMgrService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private globalEventSvc: GlobalEventService,
  ) {
    super(router, dynamicSvc, lm);
  }

  ngOnInit() {
    this.unlisten = this.renderer.listen(this.elementRef.nativeElement, 'click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.globalEventSvc.Click(event, true);

      if (this.hanja) {
        this.OpenWordHanja(this.hanja, this.hanja).subscribe(result => {
          console.log('HanjaCharComponent.onClick() : result=', result);
        });
      }
      else {
        console.error('HanjaCharComponent.onClick() : hanja is null');
      }
    });
  }

  ngOnDestroy(): void {
    if (this.unlisten) {
      this.unlisten();
      this.unlisten = null;
    }
  }
}
